import Definition from './Definition';
import DefinitionList from './DefinitionList';

export default angular.module('edge.platform.widgets.definition-list', []).component('gwDefinitionList', DefinitionList).component('gwDefinition', Definition);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/definition-list/module.js
// module id = 354
// module chunks = 0